import React from 'react';

import { FeatureExplanation } from '../feature-explanation/FeatureExplanation';
import { Feature } from '@models/feature';
import { Localize } from '@utils';

export const FeatureCorrelatedFeaturesTable: React.FC<{
  correlatedFeatures: [Feature, number][];
}> = ({ correlatedFeatures }) => {
  return (
    <table className="table" style={{ width: '100%' }}>
      <tr>
        <th className="label-bold">Feature ID</th>
        <th className="label-bold">Correlation</th>
        <th className="label-bold">Explanation</th>
      </tr>
      {correlatedFeatures.map(([{ id, explanation }, correlation]) => (
        <tr>
          <td>{id}</td>
          <td>{Localize.formatNumber(correlation)}</td>
          <td>
            {<FeatureExplanation explanationBlocks={explanation.tokens} />}
          </td>
        </tr>
      ))}
    </table>
  );
};
